import {
  Box, SvgIcon, Typography, useTheme,
} from '@mui/material';

export interface AccountMembershipsBenefitCardProps {
  icon: typeof SvgIcon;
  title: string;
  description: string;
}

export function AccountMembershipsBenefitCard({
  icon: Icon, title, description,
}: AccountMembershipsBenefitCardProps) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.brand.surface,
        border: `1px solid ${theme.palette.brand.primary}`,
        borderRadius: theme.spacing(1),
        p: theme.spacing(2.5),
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(0.625),
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: theme.spacing(0.5) }}>
        <Icon sx={{ color: theme.palette.brand.primary, fontSize: theme.spacing(2.5) }} />
        <Typography variant="labelMd" sx={{ color: theme.palette.brand.primary, fontWeight: 590 }}>
          {title}
        </Typography>
      </Box>
      <Typography variant="bodyMd" sx={{ color: theme.palette.grey[600] }}>
        {description}
      </Typography>
    </Box>
  );
}
